// extracted by mini-css-extract-plugin
var _1 = "Spinner__Spinner___WbbHI";
var _2 = "Spinner__cube1___Y0qE2";
var _3 = "Spinner__cube2___jlVnq";
var _4 = "Spinner__sk-cubemove___i_44X";
var _5 = "Spinner__wiggle___H8Hul";
export { _1 as "Spinner", _2 as "cube1", _3 as "cube2", _4 as "sk-cubemove", _5 as "wiggle" }
